import { GET, POST, PUT } from 'js/constants/requestMethods';
import { CALL_PRIVATE_API } from 'js/middleware/api';
import catalogConfigSchema from 'js/schemas/catalogConfig';
import { Dispatch } from 'redux';
import * as actionTypes from '../../constants/actionTypes';

export const loadCatalogConfigs = () => (dispatch: Dispatch<any>) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.GET_CATALOG_CONFIGS_REQUEST,
        actionTypes.GET_CATALOG_CONFIGS_SUCCESS,
        actionTypes.GET_CATALOG_CONFIGS_FAILURE,
      ],
      endpoint: '/catalog_configs',
      schema: [catalogConfigSchema],
      requestMethod: GET,
    },
  });
};

export const addCatalogConfig = (payload) => (dispatch: Dispatch<any>) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.ADD_CATALOG_CONFIG_REQUEST,
        actionTypes.ADD_CATALOG_CONFIG_SUCCESS,
        actionTypes.ADD_CATALOG_CONFIG_FAILURE,
      ],
      endpoint: '/catalog_configs',
      schema: catalogConfigSchema,
      requestMethod: POST,
      payload,
    },
  });
};

export const updateCatalogConfig = (id, payload) => (dispatch: Dispatch<any>) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.UPDATE_CATALOG_CONFIG_REQUEST,
        actionTypes.UPDATE_CATALOG_CONFIG_SUCCESS,
        actionTypes.UPDATE_CATALOG_CONFIG_FAILURE,
      ],
      endpoint: `/catalog_configs/${id}`,
      schema: catalogConfigSchema,
      requestMethod: PUT,
      payload,
    },
  });
};
